<mat-card class="facturacion-dialog">
  <app-card-header [title]="title" [draggable]="true"></app-card-header>
  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
      <mat-card-content class="facturacion-dialog-content">
        @if (seleccionable) {
          <app-cliente-selector
            formControlName="idClienteSeleccionado"
            placeholder="Elegir cliente (cualquier nivel)"
          ></app-cliente-selector>
        }

        <mat-slide-toggle formControlName="activa" color="primary">
          Facturación activa
        </mat-slide-toggle>

        <mat-slide-toggle formControlName="bonificado" color="primary">
          Bonificado (no se cobra; se descuenta del cliente padre)
        </mat-slide-toggle>
      </mat-card-content>

      <mat-divider></mat-divider>
      <mat-card-actions align="end">
        <button irxBoton="texto" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button irxBoton="principal" type="submit">Guardar</button>
      </mat-card-actions>
    </form>
  } @else {
    <div class="facturacion-dialog-loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }
</mat-card>
